var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMenuHostelWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_4508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66546 0.0625C0.861886 0.0625 0.326172 0.598214 0.326172 1.66964V30.0625H3.00474V25.7768H27.6476V30.0625H30.3262C30.3749 30.0625 30.3262 1.66964 30.3262 1.66964C30.3262 0.598214 29.7905 0.0625 28.9869 0.0625C28.1833 0.0625 27.6476 0.598214 27.6476 1.66964V10.7768H3.00474V1.66964C3.00474 0.598214 2.46903 0.0625 1.66546 0.0625ZM7.82617 2.20536C6.05097 2.20536 4.61189 3.64444 4.61189 5.41964C4.61189 7.19484 6.05097 8.63393 7.82617 8.63393C9.60137 8.63393 11.0405 7.19484 11.0405 5.41964C11.0405 3.64444 9.60137 2.20536 7.82617 2.20536ZM12.1119 4.34821V8.63393H26.0405C26.0405 6.49107 23.8201 4.34821 21.7547 4.34821H12.1119ZM3.00474 12.9196H27.6476V23.6339H3.00474C3.05521 23.6339 3.00474 12.9196 3.00474 12.9196ZM7.82617 15.0625C6.05097 15.0625 4.61189 16.5016 4.61189 18.2768C4.61189 20.052 6.05097 21.4911 7.82617 21.4911C9.60137 21.4911 11.0405 20.052 11.0405 18.2768C11.0405 16.5016 9.60137 15.0625 7.82617 15.0625ZM12.1119 17.2054V21.4911L26.0405 21.5187C26.0405 19.3482 23.8201 17.2054 21.7547 17.2054H12.1119Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_4508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.326172 0.0625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuHostelWhite);
export default __webpack_public_path__ + "static/media/new-menu-hostel-white.19ad401ad11e8410aae5182ad03bc34b.svg";
export { ForwardRef as ReactComponent };